import React, { useState, useEffect } from 'react';
import { clickable } from "../../utils/a11y";
import "../../styles/Doctor-ui/Doctor-appointment/Doctor-patient-data.css";
import PersonalInfo from './DA-personal-info';
import FileUpload from './DA-Results';
import { REFILL_OPTION } from '../../utils/refillOrder';
import SymptomAssessmentSummary from './SymptomAssessmentSummary';
import Notes from './DA-notes';
import Orders from './DA-orders';
import ReactQuillWrapper from './DA-takenote';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import Loader from '../../utils/loader';
import { API_DETAILS } from '../../App';
import Popup from 'reactjs-popup';
import { toast } from '../../utils/toast';
import { useSubmitGuard } from '../../utils/useSubmitGuard';
import { errorMessage } from '../../utils/errorMessage';
import { COOKIE_KEYS } from "../../App";
import Cookies from "js-cookie";
import 'react-quill/dist/quill.snow.css';
import { formatDate, calculateAge } from '../../utils/formatDate';

// Tabs that may be opened directly via ?tab=. Anything else falls back to
// overview, so a stale or mistyped link can never render a blank panel.
const LINKABLE_TABS = ['overview', 'personalinfo', 'results', 'notes', 'orders'];

const PatientDetails = (props) => {
  const location = useLocation();
  // Lets other screens deep-link straight to a tab — the symptom score on an
  // appointment card opens this patient's Results, where the assessment lives.
  const requestedTab = new URLSearchParams(location.search).get('tab');
  const [activeTab, setActiveTab] = useState(
    LINKABLE_TABS.includes(requestedTab) ? requestedTab : 'overview'
  );
  const [overviewTab, setOverviewTab] = useState(false);
  const [personalInfo, setPersonalInfo] = useState(false);
  const [results, setResults] = useState(false);
  const [notes, setNotes] = useState("");
  const [savingNote, guard] = useSubmitGuard();
  const [orders, setOrders] = useState(false);
  const [followup, setFollowup] = useState(false);
  const [prevAppts, setPrevAppts] = useState([]);
  const [upComingAppts, setUpcomingAppts] = useState([]);
  const [refillReqs, setRefillReqs] = useState([]);
  const [ordersData, setOrdersData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  let {patientId, apptId} = useParams();
  const [patDetails, setPatDetails] = useState();
  const [isOpenCreatePopUp, setOpenCreatePopUp] = useState(false);
  const [diagName, setDiagName] = useState(location.state?.diagId);
  const [imagePreview, setImagePreview] = useState(null);
  const [carePlanView, setCarePlanView] = useState(true);
  const [noteSubmitted,setNoteSubmitted] = useState(false);
  const [noteId,setNoteId] = useState(null);
  const [deleteNote,setDeleteNote] = useState(false);
  const [editNote,setEditNote] = useState(false);

  const handleOverview = (data) => {
    setActiveTab(data);
  }

  useEffect(() => {
    fetchAppointments();
    fetchRefillRequests();
    getPatientDetails();
    fetchPatientPicture();
  }, []);

  useEffect(() => {
    if (location.state?.diagId) {
      setDiagName(location.state.diagId);
    }
    if (apptId){
      setOpenCreatePopUp(true)
    }

  }, [apptId])

  useEffect(() => {

    const deleteNoteAsync = async () => {
      const url = API_DETAILS.baseUrl + API_DETAILS.PORT + `/youro/api/v1/deleteNotes/${noteId}`;
      try {
        const res = await axios.delete(url);
        toast.success("Note deleted.");
        setNoteSubmitted(prevState => !prevState); // Trigger re-fetch or other actions
        setDeleteNote(false); // Reset the delete flag
      } catch (err) {
        toast.error(errorMessage(err, "We couldn't delete that note. Try again in a moment."));
      }
    };
  
    // Call the async function if deleteNote flag is true
    if (deleteNote) {
      deleteNoteAsync();
    }
  
    
  }, [deleteNote])

  
  const getPatientDetails = async() => {
    const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + `/youro/api/v1/getUser/${patientId}`;
    try {
      setIsLoading(true)
      const res = await axios.get(url);
      setPatDetails(res.data);
      setIsLoading(false)
    }
    catch (err) {
      setIsLoading(false);
    }
  }


  const fetchPatientPicture = async () => {
    const get_url = API_DETAILS.baseUrl+ API_DETAILS.PORT + API_DETAILS.baseExtension +`/getDp/${patientId}`;
    try {
      const response = await axios.get(get_url,{ responseType: 'arraybuffer' });

      if (response.status === 200) {
        const arrayBuffer = new Uint8Array(response.data);
        if(arrayBuffer.length!=0)
       {
        const base64Image = btoa(
          new Uint8Array(arrayBuffer).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ''
          )
        );
        setImagePreview(`data:image/jpeg;base64,${base64Image}`);
       }
      }
    }catch (err) {
    }
  }

  const fetchAppointments = async() => {
    const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + `/youro/api/v1/appointments/${patientId}?timeZone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`;
    try {
      setIsLoading(true)
      const res = await axios.get(url);
      setPrevAppts(res.data.previousAppointments);
      setUpcomingAppts(res.data.upComingAppointments);
      setIsLoading(false)
    }
    catch (err) {
      setIsLoading(false);
    }
  }

  const TodayAppointmentList = () => {
  

  return (
    <div>
        {
          (upComingAppts==null || upComingAppts.length == 0) && <>
            <div style={{ width: '100%', height: '100%', marginTop: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <h3><i>No record of appointments</i></h3>
            </div>
          </>
        }

          {upComingAppts && upComingAppts.length!= 0 && upComingAppts.map((item) => (
            <div className='previous-appointment'> 
             <div>
             <h3 style={{display: 'inline-block'}}>
                                   {item.apptStartTime ? `${new Date(item.apptStartTime).toLocaleDateString()}, ${getTime(item.apptStartTime)}`
                              : 'Date unavailable'}</h3>{item.status == 'CANCELED' && <div className='cancel-tag'>cancelled</div>}
              <div style={{ display: 'flex',flexDirection:'row',height:'30px',marginTop:'1.5%'}}>
                  <img
                // src={item.picture? `data:image/png;base64,${item.picture}`: 'https://img.freepik.com/free-vector/businessman-character-avatar-isolated_24877-60111.jpg?w=740&t=st=1697800963~exp=1697801563~hmac=a964f83412aeedf85e035a4192fe19e1c7001f7ec339ba51104c9372481f77c9'}
                // src={item.picture!=null ? ImagePrev(item.picture): 'https://img.freepik.com/free-vector/businessman-character-avatar-isolated_24877-60111.jpg?w=740&t=st=1697800963~exp=1697801563~hmac=a964f83412aeedf85e035a4192fe19e1c7001f7ec339ba51104c9372481f77c9'}
                      src={require("../../assets/Display_icon.png")}className="profile-pic" alt="Patient Image" width="25" height="25"/>
              <h3 style={{marginTop:'3%',marginLeft:'2%'}}>
                <Link style={{ textDecoration: 'none' }} to={`/doctor-view-profile/${item.patientId}`}>{item.doctorName}</Link>
              </h3>
            </div>
            </div>
            <ul key={item.apptId}>
              {item.status != 'CANCELED' && <>
              <li onClick={() => setDiagName(item.diagId)} style={{ textDecoration: 'underline', color: 'var(--youro-sky)', cursor: 'pointer' }}><Link style={{ textDecoration: 'none' }} to={`${item.apptId}`}>View/edit the care plan</Link></li>
            <li style={{ textDecoration: 'underline', color: 'var(--youro-sky)', cursor: 'pointer' }} onClick={() => setShowEditor(item)}>Add note for doctors</li>
              </>}
            
              <li>Diagnosis: <strong>{item.diagName}</strong></li>
               {/*<li>Symptom score: {item.symptomscore}</li>*/}
              {item.status != 'CANCELED' && <li>Symptom score: <strong>{item.symptomScore}</strong></li>}
              {/* <p>{item.meetup}</p> */}
            </ul>
          </div>
        ))
        
        }
      </div>
  );
};

const PreviousAppointmentList = () => {
  

  return (
    <div>
        {
          (prevAppts==null || prevAppts.length == 0) && <>
            <div style={{ width: '100%', height: '100%', marginTop: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <h3><i>No record of previous appointments</i></h3>
            </div>
          </>
        }

          {prevAppts && prevAppts.length!= 0 && prevAppts.map((item) => (
            <div className='previous-appointment'> 
             <div>
             <h3 style={{display: 'inline-block'}}>
                                   {item.apptStartTime ? `${new Date(item.apptStartTime).toLocaleDateString()}, ${getTime(item.apptStartTime)}`
                              : 'Date unavailable'}</h3>{item.status == 'CANCELED' && <div className='cancel-tag'>cancelled</div>}
              <div style={{ display: 'flex',flexDirection:'row',height:'30px',marginTop:'1.5%'}}>
                  <img
                // src={item.picture!=null ? ImagePrev(item.picture): 'https://img.freepik.com/free-vector/businessman-character-avatar-isolated_24877-60111.jpg?w=740&t=st=1697800963~exp=1697801563~hmac=a964f83412aeedf85e035a4192fe19e1c7001f7ec339ba51104c9372481f77c9'}
                      src={require("../../assets/Display_icon.png")} className="profile-pic" alt="Patient Image" width="25" height="25"/>
              <h3 style={{marginTop:'3%',marginLeft:'2%'}}>
                <Link style={{ textDecoration: 'none' }} to={`/doctor-view-profile/${item.patientId}`}>{item.doctorName}</Link>
              </h3>
            </div>
            </div>
            <ul key={item.apptId}>
            {item.status != 'CANCELED' && <><li onClick={() => setDiagName(item.diagId)} style={{ textDecoration: 'underline', color: 'var(--youro-sky)', cursor: 'pointer' }}><Link style={{ textDecoration: 'none' }} to={`${item.apptId}`}>View/edit the care plan</Link></li>
            <li style={{ textDecoration: 'underline', color: 'var(--youro-sky)', cursor: 'pointer' }} onClick={() => setShowEditor(item)}>Add note for doctors</li></>}
              <li>Diagnosis: <strong>{item.diagName}</strong></li>
              {/* <li>Symptom score: {item.symptomscore}</li> */}
              {item.status != 'CANCELED' && <li>Symptom score: <strong>{item.symptomScore}</strong></li>}
              {/* <p>{item.meetup}</p> */}
            </ul>
          </div>
        ))
        
        }
      </div>
  );
};

  const getTime = (dateTime) => {
    return new Date(dateTime).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  };

  const fetchRefillRequests = async() => {
    const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + API_DETAILS.baseExtension +`/refillRequests/${patientId}`;

    try {
      setIsLoading(true);
      const res = await axios.get(url);
      setRefillReqs(res.data);
      setIsLoading(false);
    }
    catch (err) {
      setIsLoading(false);
    }
  }

  const handleRefillsView = (refillData, refillId) => {
    setDiagName(REFILL_OPTION);
    setOpenCreatePopUp(true);
    setOrdersData({...refillData, refillId: refillId});
  };

  const RefillRequests = () => {
    return (
      <div>
        {
          (refillReqs==null || refillReqs.length == 0) && <>
            <div style={{ width: '100%', height: '100%', marginTop: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <h3><i>No record of refill requests</i></h3>
            </div>
          </>
        }

        {refillReqs && refillReqs.length!= 0 && refillReqs.map((item) => (
          <div className='previous-appointment'>
            <div>
              <h3 style={{display: 'inline-block'}}>{new Date(item.requestedAt).toLocaleDateString()}, {getTime(item.requestedAt)}</h3>
              {item.status === 'REJECTED' && <div className='cancel-tag'>Rejected</div>}
              {item.status === 'APPROVED' && <div className='approve-tag'>Approved</div>}
            </div>
            {/* TO change status as key */}
            <ul key={item.status}>
              {item.status === 'PENDING' && <><li onClick={() => handleRefillsView(item.presRefills, item.refillId)} style={{ textDecoration: 'underline', color: 'var(--youro-sky)', cursor: 'pointer' }}> <Link style={{ textDecoration: 'none' }} to={`${item.apptId}`}> View the Refill Request</Link></li></>}
            </ul>
          </div>
        ))}
      </div>
    );
  };

  const [showEditor, setShowEditor] = useState(false);
  

  const handleCreateNoteClick = () => {
    setShowEditor(!showEditor);
  };

 const handlenoteclickclose =()=> {
   setShowEditor(false);
  }

  const handleToast = (val) => {
    if (val) toast.success("Prescription saved.")
    if(!val) toast.error("We couldn't save that prescription. Check the details and try again.")
  }

  const navigate = useNavigate();
  const closeElement = React.useRef();
  const [setapptId, setSetapptId] = useState()

  const handleNotesSubmit = guard(() => {
    let url = API_DETAILS.baseUrl + API_DETAILS.PORT;
    url += editNote ? `/youro/api/v1/updateNotes/${noteId}` : `/youro/api/v1/saveNotes`;
    const data = {
      apptId: apptId ? apptId : null,
      patientId: parseInt(patientId),
      doctorId: parseInt(Cookies.get(COOKIE_KEYS.userId)),
      notes: notes
    };
  
    const axiosMethod = editNote ? axios.put : axios.post;
    return axiosMethod(url, data).then(res => {
      toast.success("Note saved.");
      setNoteSubmitted(prevState => !prevState); // Reflects that a new note submission has occurred
      setShowEditor(false); // Assuming you have logic to toggle editor visibility
      setEditNote(false); // Set editNote to false after successful submission
      setNotes(""); // Optionally clear the notes state if you want a clean slate after submission
    }).catch(err => {   
      toast.error(errorMessage(err, "We couldn't save your note. Your text is still in the editor, so try again in a moment."));
    });
  });

  const [isMinimized, setIsMinimized] = useState(false);

  return (
    <div className='p-data'>

      <div className='p-all-data'>
        <div className='p-data-col' style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <div>
          <img style={{margin: '0px 20px 0px 0px', borderRadius: '100%', width: '100px'}} src={require("../../assets/Display_icon.png")} className="profile-pic" alt="Preview" height="100" />
          </div>
          
          <div>
            {patDetails && <><p className='label-p-data' ><strong>Name: </strong><i>{patDetails.firstName + ' ' + patDetails.lastName}</i></p>
            {/* This was the literal string '12/12/1999', so every patient's chart
                header showed the same made-up date of birth regardless of who was
                open. patDetails already carries the real one. */}
            <p className='label-p-data'><strong>DOB: </strong><i>{formatDate(patDetails.dateOfBirth)}</i>
              <strong style={{ marginLeft: '16px' }}>Age: </strong><i>{calculateAge(patDetails.dateOfBirth)}</i>
            </p></> }
          </div>
          
        </div>
        <div className='p-data-row'>
          {/* <div >Message</div> */}
            <Link style={{ textDecoration: 'none' }} to={`/doctor-chat?patientId=${patDetails?.userId}`}>Message</Link>
          {/* {showEditor && (
        <div className="floating-editor">
            <ReactQuillWrapper/>
        </div> */}
      {/* )} */}
        </div>
      </div>
      <div className='p-div-row'>
        <div
          className={`p-tabs ${activeTab === 'overview' ? 'active-tab' : ''}`}
          onClick={() => handleOverview('overview')}
        >
          Overview
        </div>
        <div
          className={`p-tabs ${activeTab === 'personalinfo' ? 'active-tab' : ''}`}
          onClick={() => handleOverview('personalinfo')}
        >
          Personal Info
        </div>
        <div
          className={`p-tabs ${activeTab === 'results' ? 'active-tab' : ''}`}
          onClick={() => handleOverview('results')}
        >
          Results
        </div>
        <div
          className={`p-tabs ${activeTab === 'notes' ? 'active-tab' : ''}`}
          onClick={() => handleOverview('notes')}
        >
          Notes
        </div>
        {/* <div
          className={`p-tabs ${activeTab === 'orders' ? 'active-tab' : ''}`}
          onClick={() => handleOverview('orders')}
        >
          Orders
        </div> */}
       </div>
       {activeTab === 'overview' && (
           <div className='all-plans-patient'>
            <div className='care-plan-details-doctor-apt'>
              <h2>Upcoming Appointments</h2>
              <div className='care-plan-details-doctor-apt-scroll-section'>
                <TodayAppointmentList/>
              </div>
            </div>
            <div className='care-plan-details-doctor-apt'>
              <h2>Previous Appointments</h2>
              <div className='care-plan-details-doctor-apt-scroll-section'>
                <PreviousAppointmentList/>
              </div>
            </div>
            <div className='care-plan-details-doctor-apt'>
              <h2>Prescription Refill Requests</h2>
              <div className='care-plan-details-doctor-apt-scroll-section'>
                <RefillRequests />
              </div>
            </div>
          </div>
           )}

      {activeTab === 'personalinfo' && (
        // <div className="tab-content">
         <PersonalInfo data={patDetails}/>
      //  </div>
      )}

      {activeTab === 'results' && (
        <>
        <SymptomAssessmentSummary patientId={patientId} />
        <FileUpload data={patientId}/>
        </>
      )}
     
      {activeTab === 'notes' && (
       <Notes patId={patientId}
       showEditor={setShowEditor} 
       noteSubmitted={noteSubmitted} 
       setNoteId={setNoteId} 
       setDeleteNote={setDeleteNote} 
       setEditNote = {setEditNote}
       setNotes= {setNotes}
       setapptId = {apptId}
       />
      )}

      {/* {activeTab === 'orders' && (
        <Orders patId={patientId}/>
      )} */}


        {showEditor && (
        <div className="floating-editor">
            {/* <button >Minimize</button>
            <button >Maximize</button> */}
            <div className='notes-title'>
              <label style={{fontWeight: '900', paddingLeft: '10px', fontSize: '20px'}}>Notes</label>
              <div className='mini-close'>
                  <button
                    style={{ borderRadius: '5px', marginRight: '6%'}}
                    onClick={() => setIsMinimized(prev => !prev)}
                  >
                    {isMinimized ? '🔼' : '🔽'}
                  </button>
                  <button style={{borderRadius: '5px'}} onClick={() => setShowEditor(null)}>X</button>
              </div>
            </div>
          {/* <ReactQuillWrapper /> */}
          {!isMinimized && (
            <>
            <ReactQuillWrapper  val={setNotes} initialValue={notes}/>
            <button onClick={() => handleNotesSubmit()} disabled={savingNote} aria-busy={savingNote} style={{right: '0px', position: 'absolute', bottom: '0px', borderRadius: '10px'}}>Submit</button>
            </>
          )}
        </div> )}
      
        <Popup className={!carePlanView ? 'order-popup': 'congrats-popup'} closeOnEscape={false} open={isOpenCreatePopUp} modal closeOnDocumentClick={false} onClose={() => {setOpenCreatePopUp(false); setDiagName(); setOrdersData({})}} contentStyle={{ maxWidth: '1200px' }}>
          <div style={{ position: 'absolute', top: '20px', right: '20px', cursor: 'pointer' }} {...clickable(() => { setOpenCreatePopUp(false); navigate("..", { relative: "path" })}, 'Close')}>
            {/* <Link to='..' relative="path"> */}
            <span className="material-symbols-outlined">
              close
            </span>
          </div>

          <div style={{ padding: '50px 20px' }}>
            <Orders setCarePlanView={setCarePlanView} patId={patientId} apptId={apptId} diag={diagName} closePopup={setOpenCreatePopUp} handleToast={handleToast} nav={() => {navigate("..", { relative: "path" })}} ordersData={ordersData} onRefillChange={fetchRefillRequests}/>
          </div>
        </Popup>

    <Loader active={isLoading} />
    </div>
  );
}

export default PatientDetails;
